var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-nav',_vm._l((_vm.links),function(item,index){return _c('b-nav-item',{key:index,attrs:{"to":item.link,"title":item.description,"b-v-tooltip.hover":""}},[_c('i',{class:`${item.icon} pr-2`,style:({color: item.icon_color})}),_vm._v("\n\t\t\t"+_vm._s(item.name)+"\n\t\t")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }